export function isQuestConnection(connection) {
    return connection.connection.qa;
}

export function isFavoriteConnection(connection) {
    return connection.connection.favorite;
}

export function isMeetingConnection(connection) {
    return connection.connection.meeting;
}

export function isChatConnection(connection) {
    return connection.connection.chat;
}
